<template>
  <el-cascader
    v-model="valueBackup"
    :options="listBackup"
    :props="{ multiple, expandTrigger: 'hover' }"
    collapse-tags
    filterable
    :clearable="clearable"
    :placeholder="placeholder"
    :show-all-levels="false"
  />
</template>

<script>
  import {getSortedStores} from '@/api/store';

  export default {
    props: {
      value: {
        type: [String, Number, Array],
        default: '',
      },
      list: {
        type: Array,
        default: () => [],
      },
      clearable: Boolean,
      multiple: Boolean,
      placeholder: {
        type: String,
        default: '请选择门店',
      },
    },
    data: () => ({
      valueBackup: '',
      listBackup: [],
      storeCount: 0,
    }),
    watch: {
      value(value) {
        if (this.multiple) {
          if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
        } else {
          if (value !== this.valueBackup) this.valueBackup = +value || '';
        }
      },
      valueBackup(valueBackup) {
        if (this.multiple) {
          if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) {
            this.$emit('input', valueBackup);

            const store_ids = [];
            valueBackup.forEach(store => store_ids.push(store[1]));
            this.$emit('change', { store_ids, is_all: store_ids.length === this.storeCount ? 1: 0 });
          }
        } else {
          if (valueBackup !== this.value) this.$emit('input', valueBackup);
        }
      },
    },
    methods: {
      async getList() {
        const { isError, data } = await getSortedStores();
        if (isError) return;

        this.listBackup = data;
        if (!data) return;
        this.storeCount = data[0].children.length + data[1].children.length;
      },
    },
    beforeMount() {
      if (this.multiple) {
        this.valueBackUp = this.value || [];
      } else {
        this.valueBackUp = +this.value || '';
      }

      if (this.list.length) return this.listBackup = this.list;

      this.getList();
    },
  };
</script>
